import { createContext, useContext } from 'react';

/**
 * Context for Select open state
 */
export const SelectOpenContext = createContext<{
  isOpen: boolean;
}>({ isOpen: false });

/**
 * Hook to access Select open state
 */
export function useSelectOpen() {
  return useContext(SelectOpenContext);
}

/**
 * Context for search functionality in Select
 */
export const SelectSearchContext = createContext<{
  searchValue: string;
  setSearchValue: (value: string) => void;
} | null>(null);

/**
 * Hook to access search context in Select
 * Use this to filter options based on search value
 */
export function useSelectSearch() {
  return useContext(SelectSearchContext);
}
